<template>
    <div class="columns">
        <div class="column">
            <ul>
                <li v-for="price in priceHistory" :key="price['.key']">
                    {{returnDate(price.date)}}: {{ returnFormatNo(price.value) }} DKK
                </li>
            </ul>
        </div>
        <div class="column">
          <a class="button is-small is-success">{{ $t("input.new") }}</a>
        </div>
    </div>
</template>

<script>
import firebase from '@/firebase'
import moment from 'moment'
import _ from 'lodash'

export default {
    name: 'PriceHistory',
    components: {
    },
    props: {
        user: Object
    },
    firebase: function() { 
        const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
        const userid = JSON.parse(localStorage.getItem('profile')).user_id;
        return {
            priceHistory: {
                source: firebase.database().ref('/organisations/' + tenantid + '/userPreferences/' + this.user['.key'] + '/priceHistory'),
                asObject: false,
            }
        }
    },
    methods: {
        returnDate(date) {
            return moment(date).format("DD/MM")
        },
        returnFormatNo(no) {
            return no.toLocaleString('da-dk');
        }
    }

}
</script>

<style>

</style>
